








































import { Button, Tooltip } from 'element-ui'
import { Vue, Prop, Component, Ref } from 'vue-property-decorator'

@Component({
  components: {
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
  },
})
export default class TermsAndConditions extends Vue {
  @Prop() termsTemplate!: string
  @Ref() readonly termsWindowRef!: HTMLElement

  termsBeenRead = false

  mounted() {
    const {
      termsWindowRef: { scrollTop, offsetHeight, scrollHeight },
    } = this

    this.termsBeenRead = scrollTop + offsetHeight > scrollHeight
  }

  get headerText() {
    if (this.termsTemplate) {
      return `To book with ${this.humanizedCompanyName} you must read and accept our terms and conditions below.`
    } else {
      return 'Sorry, there is no terms and conditions for current booking type. Please, contact administration.'
    }
  }

  updateScrollHeight(): void {
    const {
      termsWindowRef: { scrollTop, offsetHeight, scrollHeight },
    } = this

    if (scrollTop + offsetHeight > scrollHeight) {
      this.termsBeenRead = true
    }
  }
}
